/** Seed 0 preserves the authored layout. These bounds are simulation inputs. */
export const SEED_LAYOUT = {
  version: 4,
  // Close one authored exit with visible timber/stacked equipment. Seed zero
  // bypasses generation and retains both original choices.
  exits: ['corridor', 'window'],
  corridorClosure: { minX: 10, maxX: 10.6, minY: 0, maxY: 2.5, minZ: 0.5, maxZ: 2.9 },
  closureSeams: [0.5, 1, 1.5, 2],
  closureSeamThickness: 0.025,
  closureSeamOverhang: 0.005,
  windowClosure: { minX: 7, maxX: 9, minY: 0.5, maxY: 2.5, minZ: -6.05, maxZ: -5.9 },
  crossings: ['roof', 'cable', 'gap'],
  // Mirror each bed/equipment group as a unit, preserving the walkable gaps.
  corridorMirror: [false, true],
  // One-based bay numbers. Keep the late vault pair and the spruce bay intact.
  parkingBays: [
    [4, 8, 13, 16, 19, 21],
    [4, 7, 12, 16, 19, 21],
    [5, 9, 13, 17, 19, 21],
  ],
  parkingSides: [1, -1],
  // Sustained bends and long acceleration lines, as well as the classic slalom.
  // The final opposite pair still offers the optional boot-to-boot shortcut.
  parkingPatterns: [
    [1, -1, 1, -1, 1, -1],
    [1, 1, -1, -1, 1, -1],
    [1, 1, 1, 1, 1, -1],
    [1, -1, -1, -1, 1, -1],
  ],
  // X/Z offsets of the first two pallets; the roof approach stays fixed.
  palletOffsets: [
    [[-0.25, 0.25], [0.2, -0.15]],
    [[0.25, -0.25], [-0.2, 0.15]],
    [[0, 0], [0.15, 0.3]],
  ],
  hannuExitAngles: [-0.6, -0.3, 0, 0.3, 0.6],
  sleeperOffsets: [-0.2, 0, 0.2],
  sleepers: ['nukkuja-1', 'nukkuja-2', 'nukkuja-3', 'nukkuja-4'],
} as const;
